import type { ShareAccess } from "@libertify/ui";

/** Which experience-v2 access card matches the saved `publication_mode`. */
export const getShareAccess = (
  publicationMode: string | null | undefined
): ShareAccess => {
  if (publicationMode === "PasswordProtected") return "password";
  if (!publicationMode || publicationMode === "PublicLink") return "public";
  return "email";
};
